import { isFilledArray } from './isFilledArray';

import { MENU_ROUTES } from 'config';
import { Roles } from 'enums';

export const getMenuRoutes = (roles: Roles[]) => {
  if (!isFilledArray(roles)) return [];

  return MENU_ROUTES.filter(menu => menu.visibleFor.some(role => roles.includes(role)));
};
